import { ExternalLink } from '@qga/roo-ui/components';
import { CONTACT_US_URL } from 'config/constants';
import { TERMS_AND_CONDITIONS_URL } from 'config/constants';
import { createDisclaimer } from './lib/createDisclaimer';
import * as track from 'lib/gaTracking/crossPageEvents';

export const PointsDisclaimer = createDisclaimer({
  indicator: '^',
  id: 'points-disclaimer',
  body: (
    <>
      Allow up to 8 weeks for Qantas Points to appear in your account. Businesses earn 1 Qantas Point per AU$1 spent on eligible Qantas
      Hotels worldwide. Eligible Qantas hotels excludes Classic Hotel Rewards. A business must be a Qantas Business Rewards Member to earn
      Qantas Points for your business. Qantas Points are not earned on any amounts payable directly to the hotel.
      <ExternalLink
        underline
        href={TERMS_AND_CONDITIONS_URL}
        title="Open Terms and Conditions in new window"
        onClick={track.conditionsApplyLinkSelected}
      >
        Terms and conditions apply
      </ExternalLink>
    </>
  ),
});

export const FeesDisclaimer = createDisclaimer({
  indicator: '†',
  id: 'fees-disclaimer',
  body: (
    <>
      Includes fees payable in local currency directly to the hotel. Prices in AUD are approximated and based on the exchange rate at time
      of booking.
    </>
  ),
});

export const VoucherDisclaimer = createDisclaimer({
  indicator: '+',
  id: 'voucher-disclaimer',
  body: (
    <>
      Vouchers issued by Qantas are not exchangeable or redeemable for cash or other goods or services. Vouchers can only be used once and
      any unused portion of a voucher will be forfeited. The value of the voucher will not be refunded and no replacement voucher will be
      issued when canceling a booking. If you change or cancel a booking, any hotel fee amount will be deducted from the amount paid by you,
      up to a maximum of the amount originally paid by you. The hotel fee value cannot be paid using the voucher value.
    </>
  ),
});

export const ChangeDatesRequestDisclaimer = createDisclaimer({
  indicator: '‡',
  id: 'change-date-request-disclaimer',
  body: (
    <>
      Prices may differ on the requested new dates. We&apos;ll confirm the amount with the hotel on your behalf and contact you before
      processing any additional charges or refunds
    </>
  ),
});

export const CreditVoucherDisclaimer = createDisclaimer({
  indicator: '++',
  id: 'credit-voucher-disclaimer',
  body: (
    <>
      The credit voucher can only be used towards part, or full payment of hotel bookings through qantas.com and excludes Airbnb bookings.
      If there is a balance remaining to be paid for your booking, you must pay this balance with a credit/charge card. The credit voucher
      must be used within 3 years from the date of issue, or it will expire. Credit vouchers are not exchangeable or redeemable for cash or
      other goods or services. Credit vouchers may be transferred, but are not valid if sold. If you cancel a booking that was paid for with
      a credit voucher, a replacement credit voucher will be issued for the refundable amount. Availability of credit vouchers is at the
      sole discretion of Qantas Hotels, and Qantas Hotels may refuse to issue, or otherwise cancel, a credit voucher where it reasonably
      believes the customer is abusing or misusing the credit voucher offer, these terms and conditions, or the Qantas Frequent Flyer terms
      and conditions.
    </>
  ),
});

export const RefundDisclaimer = createDisclaimer({
  indicator: '*',
  id: 'refund-disclaimer',
  body: (
    <>
      Refunds to credit cards may take up to 5 business for the banks to process. Refunds of Qantas Points may take 1 business day before
      appearing in your account.
      <br />
      In the event of partial refunds due to property cancellation policies, Qantas Hotels will first refund to your credit card, and then
      the remainder to your Qantas Points account. If you would like to change this preference please{' '}
      <ExternalLink underline href={CONTACT_US_URL} onClick={track.contactUsLinkSelected}>
        contact us
      </ExternalLink>
    </>
  ),
});

export const DepositPayDisclaimer = createDisclaimer({
  indicator: '~',
  id: 'deposit-pay-disclaimer',
  body: (
    <>
      A minimum 20% deposit, payable using a payment card or using Qantas Points, is required to secure your booking. Deposit payment terms
      will only be permitted for bookings with a free cancellation option, within Australia. Final payment of the balance owing is payable 7
      days prior to the free cancellation date for the booking, at which time a payment card must be provided to secure the booking and will
      be charged with the balance owing. Where payment of the balance is not made within the required timeframe, or the payment card
      provided is declined, the booking will be cancelled in full, and the deposit will be refunded. Deposit payment terms are available at
      the discretion of Qantas, and may be removed or revoked at any time. Payment of a deposit indicates acceptance of these conditions.
    </>
  ),
});
